module.exports = __webpack_public_path__ + "static/img/tuyi.f79d3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/tuyi.png
// module id = 61wE
// module chunks = 4